import { render, staticRenderFns } from "./ThePublicContainer.vue?vue&type=template&id=e1af2990&"
import script from "./ThePublicContainer.vue?vue&type=script&lang=ts&"
export * from "./ThePublicContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports